import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import { AGREEMENT_IMPORT_WIZARD_STEPS } from './agreement-import-wizard.types';

interface AgreementImportWizardStepperProps {
  currentStep: number;
}

/**
 * Visual step indicator for the agreement import wizard. Mirrors <c>BuildingWizardStepper</c>
 * but driven by <c>AGREEMENT_IMPORT_WIZARD_STEPS</c> so the two flows evolve independently.
 */
export function AgreementImportWizardStepper({ currentStep }: AgreementImportWizardStepperProps) {
  const { t } = useTranslation('agreements');

  return (
    <div className="w-full max-w-4xl mx-auto mb-2">
      <div className="flex items-start w-full">
        {AGREEMENT_IMPORT_WIZARD_STEPS.map((step, index) => (
          <div key={step.key} className="flex-1 flex flex-col items-center">
            <div className="flex items-center w-full">
              <div
                className={classNames(
                  'w-full h-1 rounded-full',
                  index === 0 ? 'invisible' : step.step <= currentStep ? 'bg-brand-primary' : 'bg-white/10',
                )}
              />
              <div
                className={classNames(
                  'shrink-0 w-6 h-6 rounded-full flex items-center justify-center text-xs font-medium',
                  step.step < currentStep && 'bg-brand-primary text-black',
                  step.step === currentStep && 'bg-brand-primary text-black ring-2 ring-brand-primary/40',
                  step.step > currentStep && 'bg-white/10 text-white/60',
                )}
              >
                {index + 1}
              </div>
              <div
                className={classNames(
                  'w-full h-1 rounded-full',
                  index === AGREEMENT_IMPORT_WIZARD_STEPS.length - 1
                    ? 'invisible'
                    : step.step < currentStep
                      ? 'bg-brand-primary'
                      : 'bg-white/10',
                )}
              />
            </div>
            <span
              className={classNames(
                'mt-2 text-[10px] uppercase tracking-wide text-center',
                step.step === currentStep ? 'text-white' : 'text-white/50',
              )}
            >
              {t(`agreementImport.wizard.steps.${step.key}`)}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
